import { registerMap } from 'echarts';
import { getMap } from '@/echarts/map';

// 初始化ECharts相关配置
export const initECharts = async () => {
  try {
    // 注册地图数据
    const mapData = await getMap();
    registerMap('organ_diagram', { svg: mapData });
  } catch (error) {
    console.error('Failed to register ECharts map:', error);
  }
};